import React, { FC } from 'react';
import { StatementBox } from 'src/components';
import { ConstraintsTitle } from '../atoms';
import { PortfolioPlatformCreditScore } from '../../../model';
import { CriteriaRow } from '../..';
import styles from './PlatformCreditScore.module.scss';

type Props = {
  isViewPage: boolean;
  platformCreditScores: PortfolioPlatformCreditScore[];
  onChange: (name: string, value: number) => void;
};

const PlatformCreditScore: FC<Props> = ({ isViewPage, platformCreditScores, onChange }) => {
  return (
    <StatementBox className={styles.box}>
      <ConstraintsTitle title="Platform Credit Score" />

      <div className={styles.content}>
        {platformCreditScores?.map(({ id, percentage }) => (
          <CriteriaRow
            key={id}
            label={id}
            value={percentage}
            onChange={(value) => onChange(id, value)}
            readOnly={isViewPage}
          />
        ))}
      </div>
    </StatementBox>
  );
};

export default PlatformCreditScore;
